/* eslint-disable linebreak-style */
/* eslint-disable no-tabs */

export default [
  {
    id: 1,
    plek: 'vloer',
    title: 'GEZOCHT: LOODGIETER',
    aanhef: 'ONS TEAM ZOEKT JOU!',
    body: [
      'Vanwege de groei van onze organisatie zijn wij, voor landelijke projecten, op zoek naar een installatie-monteur/loodgieter.  Jij bent de loodgieter die zijn werk als geen ander kent en helemaal thuis is in de installaties.',
      'Ons team is op zoek naar een loodgieter voor projecten in de randstad. Als vakman hoef jij maar naar een probleem te kijken en weet op een creatieve, en efficiënte wijze de problemen op te lossen en te verhelpen. Je loopt niet weg voor complexe problemen maar denkt en werkt in oplossingen en enthousiast wordt bij het behalen van het resultaat.',
      'In deze functie houd jij je bezig met het plaatsen en van het onderhoud van gas-, water- en cv- installaties van leidingwerk tot het afmonteren van sanitair. Wij hebben diverse korte en langdurige projecten in de utiliteitsbouw, woningbouw, renovatieprojecten. Deze werkzaamheden voer je op uitdagende projecten uit in de utiliteit.',
      'Als Loodgieter ben jij het visitekaartje van DNZ Projects dus van jou wordt dan ook verwacht dat je representatief, servicegericht en klantvriendelijk bent. ',
    ],

    'wij zoeken': [
      'MBO installatietechniek of voldoende vakkennis',
      '5 jaar ervaring',
      'VCA-VOL Diploma of bereid dit te halen',
      'Rijbewijs B en in het bezit van eigen vervoer',
      'Zelfstandig en nauwkeurig kunnen werken',
      'Flexibel en een positieve uitstraling',
      'Goede communicatie vaardigheden',
      'Representatief',
    ],

    'wij bieden': [
      'Een afwisselende baan met goede arbeidsvoorwaarden en er is ruimte voor persoonlijke ontwikkeling.',
      'Een aantrekkelijk salaris, afhankelijk van ervaring en opleiding;',
      'Reiskostenvergoeding;',
      'Ruimte voor opleidings- en doorgroeimogelijkheden;',
      'Goede pensioenregeling;',
      'Persoonlijke werkgever aandacht voor jou en je werk;',
      'Leuke afwisselende projecten.',
      'Salaris conform Cao',
    ],
    slot: 'Heeft dit jouw interesse gewekt, wil je graag in aanmerking komen voor deze functie? ',
  },

  {
    id: 2,
    plek: 'vloer',
    title: 'GEZOCHT: Elektromonteur',
    aanhef: 'ONS TEAM ZOEKT JOU!',
    body: [
      'Vanwege de groei van onze organisatie zijn wij, voor landelijke projecten, op zoek naar een Elektromonteur.  Jij bent de monteur die zijn werk als geen ander kent en helemaal thuis is in de installaties.',
      'Ons team is op zoek naar een Elektromonteur voor onze projecten. Als vakman hoef jij maar naar een probleem te kijken en weet op een creatieve, en efficiënte wijze de problemen op te lossen en te verhelpen. Je loopt niet weg voor complexe problemen maar denkt en werkt in oplossingen en enthousiast wordt bij het behalen van het resultaat.',
      'In deze functie houd jij je bezig met het plaatsen en van het E-, I-, L-, BMI-, Ontruiming- en toegangssystemen-installaties. Wij hebben diverse korte en langdurige projecten in de utiliteitsbouw, woningbouw, renovatieprojecten. Deze werkzaamheden zijn landelijk. ',
      'Als Elektromonteur ben jij het visitekaartje van DNZ Projects dus van jou wordt dan ook verwacht dat je representatief, servicegericht en klantvriendelijk bent. ',
    ],

    'wij zoeken': [
      'MBO installatietechniek of voldoende vakkennis',
      '5 jaar ervaring',
      'VCA-VOL Diploma of bereid dit te halen',
      'Rijbewijs B en in het bezit van eigen vervoer',
      'Zelfstandig en nauwkeurig kunnen werken',
      'Flexibel en een positieve uitstraling',
      'Goede communicatie vaardigheden',
      'Representatief',
    ],

    'wij bieden': [
      'Een afwisselende baan met goede arbeidsvoorwaarden en er is ruimte voor persoonlijke ontwikkeling.',
      'Een aantrekkelijk salaris, afhankelijk van ervaring en opleiding;',
      'Reiskostenvergoeding;',
      'Ruimte voor opleidings- en doorgroeimogelijkheden;',
      'Goede pensioenregeling;',
      'Persoonlijke werkgever aandacht voor jou en je werk;',
      'Leuke afwisselende projecten.',
      'Salaris conform Cao',
    ],
    slot: 'Heeft dit jouw interesse gewekt, wil je graag in aanmerking komen voor deze functie? ',
  },
];
